import { useEffect, useState } from 'react';
import axios from 'axios';
import WelcomePopup from './WelcomePopup';
import PromoPopup from './PromoPopup';

/**
 * Decides which single popup the visitor sees. While a promotion with its
 * announcement enabled is running it takes over; otherwise the newsletter
 * popup behaves as before. Only ever one of them renders.
 */
export default function SitePopups() {
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [promotion, setPromotion] = useState(null);
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await axios.get(localhost + 'active-promotion');
        if (!cancelled && res.data?.id && res.data?.popup_enabled) {
          setPromotion(res.data);
        }
      } catch (e) {
        // No promotion endpoint / network issue — fall back to the newsletter popup.
      } finally {
        if (!cancelled) setResolved(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [localhost]);

  // Wait for the answer so the newsletter popup can't flash before the
  // promotion one takes priority.
  if (!resolved) return null;

  return promotion ? <PromoPopup promotion={promotion} /> : <WelcomePopup />;
}
